import React, { useRef, useState } from "react";
import { useInView } from "framer-motion";
import CountUp from "react-countup";

type Props = { value: number; suffix?: string; label: string; testId?: string; dark?: boolean };

/** Count-up stat with thin accent line drawing in as the count completes. */
export default function CountUpStat({ value, suffix = "", label, testId, dark = false }: Props) {
  const ref = useRef<HTMLDivElement | null>(null);
  const isInView = useInView(ref, { once: true, amount: 0.4 });
  const [done, setDone] = useState(false);
  const numColor = dark ? "text-white" : "text-[#0A1628]";
  const labelColor = dark ? "text-white/60" : "text-[#6B7280]";

  return (
    <div ref={ref} className="relative" data-testid={testId}>
      <div className={`font-display text-5xl md:text-6xl font-extrabold tracking-tightest ${numColor} leading-none`}>
        {isInView ? <CountUp end={value} duration={1.6} onEnd={() => setDone(true)} /> : 0}
        <span className="text-[#FFC93A]">{suffix}</span>
      </div>
      <div className={`mt-3 text-xs uppercase tracking-[0.22em] ${labelColor} font-medium`}>{label}</div>
      <div className={`mt-4 h-px bg-[#FFC93A] transition-[width] duration-700 ease-out ${done ? "w-16" : "w-0"}`} />
    </div>
  );
}
